export default "__VITE_ASSET__DuFrL7Zd__"